<ng-container *ngIf="viewModel$ | async as viewModel">
    <table *ngIf="viewModel.assets.length" mat-table [dataSource]="viewModel.assets" matSort (matSortChange)="onSort($event)" matSortDisableClear [matSortStart]="'desc'">
          <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
              <mat-checkbox appAuthorizeControl="edit||offermang" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [disabled]="!viewModel.assets.length">
              </mat-checkbox>
            </th>
            <td class="no-ellipsis" mat-cell *matCellDef="let row">
              <mat-checkbox appAuthorizeControl="edit||offermang" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!--  Image Column -->
          <ng-container matColumnDef="Image">
            <th style="width:8%" mat-header-cell *matHeaderCellDef>
               Preview
           </th>
            <td mat-cell class="offer-image" *matCellDef="let record">
                <!-- <img *ngIf="record.Detail.FileName" src="{{viewModel.assetsUrl}}/{{record.Detail.FileName}}" alt="Offer image">
                <img *ngIf="!record.Detail.FileName" src="./assets/images/default-image.png" alt="Offer image"> -->
                <ng-container *ngIf="record?.Detail?.FileName && assetsUrl$ | async as assetsUrl">
                    <img mat-card-md-image [src]="getImageSrc(assetsUrl, record)" alt="Offer image">
                </ng-container>
                <img mat-card-md-image *ngIf="!record.Detail.FileName"
                    src="./assets/images/default-image.png" alt="Offer image">
            </td>
           </ng-container>

        <!-- Id Column -->
        <ng-container matColumnDef="Id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id">
                Id
            </th>
            <td mat-cell title="{{ record.Detail.Id }}" *matCellDef="let record">{{ record.Detail.Id }}</td>
        </ng-container>

        <!-- AssetName Column -->
        <ng-container matColumnDef="AssetName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name">
                Asset Name
            </th>
            <td mat-cell title="{{ record?.AssetName }}" *matCellDef="let record"> {{ record?.AssetName }}</td>
        </ng-container>

        <!-- FileName Column -->
        <ng-container matColumnDef="FileName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by FileName">
                File Name
            </th>
            <td mat-cell title="{{ record?.Detail?.FileName }}" *matCellDef="let record">{{ record?.Detail?.FileName }}</td>
        </ng-container>

        <!-- DateAdded Column -->
        <ng-container matColumnDef="DateAdded">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by DateAdded">
                Date Added
            </th>
            <td mat-cell *matCellDef="let record">{{ record?.DateAdded }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="Type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Type">
                Type
            </th>
            <td mat-cell *matCellDef="let record">{{ record?.Type }}</td>
        </ng-container>

         <!-- ClientKey Column -->
         <ng-container matColumnDef="ClientKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ClientKey">
                Client Key
            </th>
            <td mat-cell *matCellDef="let record">{{ record?.Detail?.ClientKey }}</td>
        </ng-container>


        <!-- Actions Column -->
        <ng-container matColumnDef="Actions">
            <th appAuthorizeControl="edit||offermang" mat-header-cell *matHeaderCellDef>Actions</th>
            <td appAuthorizeControl="edit||offermang" mat-cell *matCellDef="let record">
                <a [routerLink]="[ record?.Detail?.Id, 'rank']">Rank</a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <table *ngIf="!viewModel.assets.length">
        <tr>
            <td class="no-records" [attr.colspan]="displayedColumns.length">
                <h2>No Records Found</h2>
            </td>
        </tr>
    </table>

    <!-- pager -->
    <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)" *ngIf="viewModel.assets.length"
        showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
    </mat-paginator>

</ng-container>
